import Stories from "@/components/site/Stories";
import { Star } from "lucide-react";

// Playlist: Celebrities Stem Cells
const ITEMS = [
  { title: "Ray Mysterio Stem Cell Therapy", youtubeId: "uAkEmsbyAc8" },
  { title: "Mike Tyson Stem Cell Therapy", youtubeId: "EnYw5Fem4wU" },
  { title: "Tony Robbins Stem Cell Therapy", youtubeId: "rqcvtQYEBkE" },
  { title: "Chuck Liddell Stem Cell", youtubeId: "orfwgR6pyhw" },
  { title: "Rampage Jackson Stem Cells", youtubeId: "yfUxKCDFD4s" },
  { title: "Ronnie Coleman Stem Cells", youtubeId: "_vhKIpqtsi8" },
  { title: "Celebrities Wearing X39", youtubeId: "0Eg10svI-1U" },
  { title: "Danny Glover Uses X39 | LifeWave", youtubeId: "T6myyju51xQ" },
];

export default function Celebrities() {
  return (
    <Stories
      id="celebrities"
      testid="celebrities-section"
      label="∙ Spotlight"
      title="Celebrities &"
      highlight="Champions."
      description="Celebrities seeing benefits from stem cells. Click each item to watch."
      Icon={Star}
      items={ITEMS}
    />
  );
}
